import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class GtagService {

	constructor() {

	}
	gtag(type, event, jsonData){
		if(typeof window['gtag'] == "function"){
			let gtag = window['gtag'];
			gtag(type, event, jsonData);
		}
	}

  	purchase(order:any){
		let jsonData = {
			"transaction_id": "" + order.entity_id,
			"affiliation": "EntreLabel: " + order.customer_firstname + " " + order.customer_firstname,
			"value": order.base_grand_total,
			"currency": order.base_currency_code,
			"tax": order.base_tax_amount,
			"shipping": order.base_shipping_amount,
			"items": []
		}

		let listPosition = 1;
		order.items.forEach((item, key) => {
			if(item.parent_item){
				jsonData.items.push({
					"id": item.sku,
					"name": item.name,
					"list_name": item.name,
					"brand": "",
					"category": "",
					"variant": item.name,
					"list_position": 2,
					"quantity": listPosition,
					"price": '' + item.price
				});
				listPosition++;
			}
		});
		this.gtag('event', 'purchase', jsonData);
  	}

	conversion(order:any){
		let jsonData = {
			'send_to': 'AW-870750764/NkkfCL7n0tcBEKy0mp8D', /** AW-870750764/NkkfCL7n0tcBEKy0mp8D */
			'value': order.base_grand_total,
			'currency': order.base_currency_code,
			'transaction_id': order.increment_id
		}
		this.gtag('event', 'conversion', jsonData);
	}
}
